import React, { useCallback, useContext, useEffect, useState } from 'react';
import { dataSender, getData } from '../../../../common/utils/router';
import { zendoStorage } from '../../../../hybrid/wrappers';
import UserContext, { StoreContext, UserProfileContext } from '../../../../common/utils/getContext';
import { API_SERVER_URL } from '../../../../common/utils/utils';
import css from './StoreProductView.module.scss';
import ProductMain from '../GT/ProductMain/ProductMain';
import { useWindowDimensions } from '../../../../common/utils/windowDimensions';
import Skeleton from '../../../../widgets/plug/Skeleton/Skeleton';
import { productMainSkeleton } from '../StoreProductWrapper/helpers';

const RenderData = ({ productWithCurrency, addProduct, translates }) => {
    return (
        <div className={css.storeWrapperMobileWhite}>
            <ProductMain dataProduct={productWithCurrency} funcs={{ add: addProduct }} translates={translates} />
        </div>
    );
};

const StoreView = ({ translates, setProductWithCurrency, productWithCurrency, prodId }) => {
    const { cartData, setCartData, setCart, isLoading } = useContext(StoreContext);
    const { userToken, lang, setAlertData, localization, storageLoaded } = useContext(UserContext);
    const { profileData } = useContext(UserProfileContext);

    const width = useWindowDimensions(true);

    const [loadingPrice, setLoadingPrice] = useState(true);

    useEffect(() => {
        setLoadingPrice(true);
        if ((userToken && !profileData) || !storageLoaded || !prodId) return;
        getData(
            `/api/v1/shop/products/${prodId}?breadcrumbs=true`,
            userToken,
            lang,
            false,
            profileData?.currency?.code || localization.currency
        ).then((data) => {
            setProductWithCurrency(data?.data);
            setLoadingPrice(false);
        });
    }, [localization, lang, userToken, profileData, prodId]);

    useEffect(() => {
        if (productWithCurrency) {
            setLoadingPrice(false);
        } else {
            setLoadingPrice(true);
        }
    }, [productWithCurrency]);

    const [adding, setAdding] = useState(false);
    const addProduct = useCallback(async () => {
        // TODO refactoring
        if (adding) {
            return;
        }
        setAdding(true);
        let cartId = cartData.id;
        if (!cartId) {
            let newCartIdRest = await fetch(`${API_SERVER_URL}/api/v1/shop/carts`, { method: 'POST' });
            let newCartId = await newCartIdRest.json();
            window && zendoStorage.set('cart_id', newCartId.data.id);
            cartId = newCartId.data.id;
        }
        dataSender(
            `${API_SERVER_URL}/api/v1/shop/carts/${cartId}/add-product`,
            'POST',
            {
                product_id: productWithCurrency.id,
                quantity: 1
            },
            (response) => {
                setCartData(response.data?.data);
                setCart(true);
                setAdding(false);
            },
            (data) => {
                if (data.message) {
                    setAlertData({ type: 'error', cont: data.message });
                    setAdding(false);
                }
            },
            userToken,
            lang,
            profileData?.currency?.code || localization?.currency
        );
    }, [
        cartData.id,
        adding,
        productWithCurrency?.id,
        lang,
        localization?.currency,
        setAlertData,
        setCart,
        setCartData,
        userToken,
        profileData
    ]);

    return (
        <Skeleton
            wrapperStyles={{
                className: css.storeWrapperMobileWhite
            }}
            wait={!loadingPrice && !isLoading}
            elements={productMainSkeleton(width)}
            Component={RenderData}
            componentProps={{ productWithCurrency, addProduct, translates }}
        />
    );
};
export default StoreView;
